import { httpsCallable } from 'firebase/functions';
import { databaseId, functions } from '@/lib/firebase';

export type SupportCategory = 'bug' | 'safety' | 'suggestion' | 'other';

export interface SubmitSupportMessageInput {
  category: SupportCategory;
  message: string;
}

const submitSupportMessageFn = httpsCallable<
  { databaseId: string } & SubmitSupportMessageInput,
  { success: true }
>(functions, 'submitSupportMessage');

export const supportService = {
  async submitMessage(input: SubmitSupportMessageInput): Promise<void> {
    await submitSupportMessageFn({ databaseId, ...input });
  },
};
